import { IProductSliderBlockViewModel } from 'Types/Litium';
import ProductSlider from 'Components/ProductSlider/ProductSlider';

interface ProductSliderBlockViewModel extends IProductSliderBlockViewModel {
    shouldLazyLoad?: boolean;
    showSizes?: boolean;
}

const ProductSliderBlock = ({
    freeText,
    itemsToShowDesktop,
    itemsToShowMobile,
    marginBetweenSlidesDesktop,
    marginBetweenSlidesMobile,
    autoSlide,
    showArrows,
    products,
    textWidth,
    translations,
    autoSlideTime,
    showSizes = false,
    shouldLazyLoad = false,
}: ProductSliderBlockViewModel) => (
    <ProductSlider
        showSizes={showSizes}
        marginBetweenSlidesDesktop={marginBetweenSlidesDesktop}
        marginBetweenSlidesMobile={marginBetweenSlidesMobile}
        products={products}
        showArrows={showArrows}
        autoSlide={autoSlide}
        itemsToShowDesktop={itemsToShowDesktop}
        itemsToShowMobile={itemsToShowMobile}
        translations={translations}
        freeText={freeText}
        textWidth={textWidth}
        autoSlideTime={autoSlideTime}
        shouldLazyLoad={shouldLazyLoad}
    />
);

export default ProductSliderBlock;
